import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorSpecificComponent } from './vendor-specific.component';
import {HelperModule} from '../../../helper/helper.module';

import {HttpClientModule, HttpClient} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  imports: [
    CommonModule,
    HelperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [VendorSpecificComponent]
})
export class VendorSpecificModule { }



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/vendor-specific/vendor-specific.module.ts